import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { LinkButton } from '@/components/buttons';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { routeMap } from '@/routes/routeMap';

type Payload = {
  transactionId: string;
};

const WithdrawalSuccess = ({ payload, closeModal }: ModalProps<Payload>) => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('WithdrawalSuccess.title')}>
      <p>{t('WithdrawalSuccess.info')}</p>
      <ModalActions>
        <LinkButton to={routeMap.credit.monthlyPayment} onClick={closeModal}>
          {t('WithdrawalSuccess.button')}
        </LinkButton>
        <LinkButton
          variant="secondary"
          to={routeMap.fairnessReceipt.transactionId(payload.transactionId)}
          onClick={closeModal}
        >
          {t('WithdrawalSuccess.fairnessReceiptButton')}
        </LinkButton>
      </ModalActions>
    </Modal>
  );
};

export default WithdrawalSuccess;
